<template>
  <fieldset v-show="showServices">
      <input
      type="hidden"
      :name="`${errorFieldId}`"
      :value="currentSelectionKey"
      :data-vv-scope="validationScope"
      v-validate.continues="`${errorFieldId}`"/>

    <div class="tla-form-group tla-form-group--has-sub-label">
      <label class="tla-form-group__label">{{title}}</label>
      <p class="tla_form-group__sub-label">{{subTitle}}</p>

      <div class="tla-enquiry-services">
        <label class="tla-enquiry-services__item" :class="{ 'tla-enquiry-services__item--error': isInvalid }">
          <img class="tla-enquiry-services__image" src="~@/assets/images/quote-service.png" />
          <div class="tla-enquiry-services__body">
            <label class="tla-check">
              <input class="tla-check__checkbox" type="checkbox" v-model="isQuoteRequestChecked" />
              <div class="tla-check__indicator"></div>
            </label>
            <h2 class="tla-enquiry-services__text tla-enquiry-services__text--lg">Quote</h2>
            <p class="tla-enquiry-services__text">{{quoteDescription}}</p>
          </div>
        </label>

        <label class="tla-enquiry-services__item" :class="{ 'tla-enquiry-services__item--error': isInvalid }">
          <img class="tla-enquiry-services__image" src="~@/assets/images/test-drive-service.png" />
          <div class="tla-enquiry-services__body">
            <label class="tla-check">
              <input class="tla-check__checkbox" type="checkbox" v-model="isTestDriveChecked" />
              <div class="tla-check__indicator"></div>
            </label>
            <h2 class="tla-enquiry-services__text tla-enquiry-services__text--lg">Test Drive</h2>
            <p class="tla-enquiry-services__text">{{testDriveDescription}}</p>
          </div>
        </label>
      </div>
    </div>
  </fieldset>
</template>

<script lang='ts'>
import {
  Component, Inject, Prop, Vue
} from 'vue-property-decorator';
import IEnquiryChoices from '@/models/interfaces/IEnquiryChoices';
import IVehicle from '@/models/vehicle/interfaces/vehicle.d';
import { Validator } from 'vee-validate';
import { validationService } from '../../services/ValidationService';

// Custom vee-validate
Validator.extend('enquiry-services', {
  getMessage: (field: string) => 'Please select a enquiry service',
  validate: (value: string) => validationService
    .isEnquiryServicesDataSet()
});

@Component
export default class EnquiryServicesComponent extends Vue {
  @Inject('$validator') public $validator!: Validator;

  @Prop({ default: false })
  public hideServices!: boolean;

  @Prop({ default: 'Choose a Service' })
  public title!: string;

  @Prop({ default: 'Select as many as you like...' })
  public subTitle!: string;

  @Prop({ default: 'It\'s always a good idea to know how much the vehicle will cost.' })
  public quoteDescription!: string;

  @Prop({ default: 'Experience the car first hand by selecting a test drive.' })
  public testDriveDescription!: string;

  @Prop({ default: false })
  public isTestDriveEnquiry!: boolean;

  @Prop({ default: false })
  public isQuoteEnquiry!: boolean;

  @Prop({ default: false })
  public isMotabilityEnquiry!: boolean;

  @Prop({ default: null })
  public validationScope!: string;

  public get currentSelectionKey(): string {
    return `quote:${this.isQuoteRequestChecked}:td:${this.isTestDriveChecked}:invalid:${this.isInvalid}`;
  }

  public get isTestDriveChecked(): boolean {
    return this.$store.getters['enquiryModule/testDriveRequested'];
  }

  public set isTestDriveChecked(value: boolean) {
    this.$store.dispatch('enquiryModule/submitTestDriveChecked', value);
  }

  public get isQuoteRequestChecked(): boolean {
    return this.$store.getters['enquiryModule/quoteRequested'];
  }

  public set isQuoteRequestChecked(value: boolean) {
    this.$store.dispatch('enquiryModule/submitQuoteChecked', value);
  }

  public get isInvalid(): boolean {
    return this.$store.getters['enquiryModule/enquiryChoicesContainsErrors'];
  }

  public get currentVehicle(): IVehicle | null {
    return this.$store.getters['vehicleModule/currentVehicle'];
  }

  public get errorFieldId(): string {
    return 'enquiry-services';
  }

  public get showServices(): boolean {
    if (this.hideServices) {
      return false;
    }

    if (this.currentVehicle && this.currentVehicle.derivativeId && this.currentVehicle.derivativeId > 0) {
      return true;
    }

    return false;
  }

  public mounted() {
    const choices: IEnquiryChoices = {
      isTestDriveEnquiry: this.isTestDriveEnquiry,
      isQuoteEnquiry: this.isQuoteEnquiry,
      isBrochureEnquiry: false,
      isBasicEnquiry: false,
      isDigitalBrochureEnquiry: false,
      isMotabilityEnquiry: this.isMotabilityEnquiry
    };

    this.$store.dispatch('enquiryModule/submitEnquiryChoices', choices);
  }
}
</script>
